/**
 * LERA Smart Selector — Dawn Bridge (Sprint 8.3C.3)
 * Keeps product-info.js working while LERA owns state/events.
 */
window.LeraSmartSelector = window.LeraSmartSelector || {};

(function (LSS) {
  LSS.bridge = LSS.bridge || {};

  LSS.bridge.getVariantRoot = function getVariantRoot(host) {
    return host?.querySelector?.('variant-selects') || null;
  };

  LSS.bridge.syncFormVariantInput = function syncFormVariantInput(sectionId, variantId) {
    if (!sectionId) return;

    document
      .querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}`)
      .forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (!input) return;
        const nextValue = variantId ?? '';
        if (input.value === String(nextValue)) return;
        input.value = nextValue;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  };

  LSS.bridge.readConfigFromHost = function readConfigFromHost(host) {
    if (!host) return {};

    return {
      selectorMode: host.dataset.displayMode || 'automatic',
      renderMode: host.dataset.renderMode || 'button',
      variantCount: Number(host.dataset.variantCount) || 0,
      threshold: Number(host.dataset.threshold) || 12,
      sectionId: host.dataset.sectionId || null,
      product: {
        id: Number(host.dataset.productId) || null,
        handle: host.dataset.productHandle || '',
        title: host.dataset.productTitle || '',
      },
    };
  };
})(window.LeraSmartSelector);
